module.exports = __webpack_public_path__ + "assets/img/teacher (12).d9ba2263.png";